module.exports = __webpack_public_path__ + "img/组6041.9b568d0b.png";